export default {
  //domain: "https://skynz-dev.au.auth0.com",
  domain:process.env.REACT_APP_AUTH0_DOMAIN!,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID!,
  //clientId :'eJivcFCFSmqmKSucIGriUcRGEfCU6TI9',
  scope:
    '',
  audience: 'https://skynz-dev.au.auth0.com/userInfo',
};
